import PropTypes from 'prop-types'

import styles from './CalificacionProducto.module.css'
import Opiniones from './Opiniones'

const MAX_ESTRELLAS = 5

const CalificacionProducto = (props) => {
  const arrayCalificacionPromedio = props.calificacion.map((e) => e.promedioCalificacion)
  const calificacionPromedio = arrayCalificacionPromedio[0]

  return (
    <div className={styles.calificacionProducto}>
      <p className={styles.tituloDetalle}>
        Opiniones del Producto
        <i className="fa fa-caret-right ml-2" aria-hidden="true"></i>
      </p>
      <div className={styles.informacion}>
        <div className="col">
          <div className="row">
            <div className="col">
              <p className={styles.puntuacion}>
                Puntuación promedio:
                {[...Array(MAX_ESTRELLAS)].map((_, i) => (
                  <i
                    key={i}
                    className={`fa ${i < calificacionPromedio ? 'fa-star' : 'fa-star-o'} yellow-star ml-1`}
                    aria-hidden="true"
                  ></i>
                ))}
              </p>
              <hr />
            </div>
          </div>
          {props.calificacion.map((e) => (
            <Opiniones
              key={e.idCalificacion}
              calificacion={e.calificacionAlItem}
              comentario={e.comentario}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

CalificacionProducto.propTypes = {
  calificacion: PropTypes.arrayOf(
    PropTypes.shape({
      idCalificacion: PropTypes.number.isRequired,
      promedioCalificacion: PropTypes.number.isRequired,
      calificacionAlItem: PropTypes.number.isRequired,
      comentario: PropTypes.string.isRequired
    })
  ).isRequired
}

export default CalificacionProducto
